var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DeleteTrashedEntriesForever, OpenConfirmDialog, RestoreTrashedEntries, } from '../../state/actions/commands';
import { DriveContextActions } from '../drive-context-actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
var noopTrue = function () { return true; };
var ɵ0 = noopTrue;
var TrashActions = /** @class */ (function (_super) {
    __extends(TrashActions, _super);
    function TrashActions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.actions = [
            {
                viewName: 'Restore',
                icon: 'restore',
                showInCompact: true,
                execute: function () {
                    _this.store.dispatch(new RestoreTrashedEntries());
                },
                visible: noopTrue,
            },
            {
                viewName: 'Delete Forever',
                icon: 'delete-forever',
                showInCompact: true,
                execute: function () {
                    _this.deleteForever();
                },
                visible: noopTrue,
            },
        ];
        return _this;
    }
    TrashActions.prototype.deleteForever = function () {
        this.store.dispatch(new OpenConfirmDialog({
            title: 'Delete Forever',
            body: 'This will permanently delete selected items.',
            bodyBold: 'This action can not be undone.',
            ok: 'Delete Forever',
        }, new DeleteTrashedEntriesForever()));
    };
    TrashActions.ngInjectableDef = i0.defineInjectable({ factory: function TrashActions_Factory() { return new TrashActions(i0.inject(i1.Store)); }, token: TrashActions, providedIn: "root" });
    return TrashActions;
}(DriveContextActions));
export { TrashActions };
export { ɵ0 };
